import React from 'react';
import { Redirect } from 'react-router-dom';

export default function NotFound(props) {
  return <Redirect to="/" />;
}
